import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryFileRegisterService = (
  data: any,
  signal: AbortSignal,
) => {
  return axiosInstance
    .post(ENDPOINTS.ADMIN.EXTERNAL_DELIVERY.CREATE_FILE, data, { signal })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
